module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('datepicker', {
    attrs: {
      "local": _vm.local,
      "clearable": _vm.clearable,
      "range-separator": ":",
      "format": _vm.$t("format.time.date")
    },
    model: {
      value: (_vm.internalDateRange),
      callback: function($$v) {
        _vm.internalDateRange = $$v
      },
      expression: "internalDateRange"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a7c7c2e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/daterangepicker/Daterangepicker.vue
// module id = 2039
// module chunks = 1